import Image from "next/image";
import Link from "next/link";
import { StrapiStore } from "~/shared-types";
import { getFormattedImageAttributes } from "~/utils/getImageAttributes";
import { getRoute } from "~/utils/getRoute";

export function ProductOwner({ store }: { store: StrapiStore | null }) {
  if (!store) return null;

  const image = store.attributes.storeImage.data;
  const name = store.attributes.name;

  if (!image || !name) return null;

  return (
    <Link
      href={getRoute("/stores/:id", {
        id: store.id,
      })}
      className="flex items-center max-w-max rounded-full mb-5"
    >
      <Image
        className="aspect-square w-16 h-16 object-cover rounded-full mr-4"
        {...getFormattedImageAttributes(image, "thumbnail")}
      />
      <p className="text-sm text-secondary-700 mr-5">
        <span className="block">Forhandles af</span>
        <span className="block text-primary">{name}</span>
      </p>
    </Link>
  );
}
